<template>
    <div
        :style="{
            width: '800px',
        }"
    >
        <div class="sticky-header">
            <v-tabs
                v-model="activeTab"
                fixed-tabs
                style="background-color: transparent !important; border-radius: 12px"
            >
                <v-tab key="0"> Tutoriels </v-tab>
                <v-tab
                    v-if="
                        starterComponents === 'Sans starterComponents' ||
                        starterComponents === null ||
                        localEnv !== 'production'
                    "
                    key="1"
                >
                    Modules
                </v-tab>
                <v-tab key="2"> Suivi personnel </v-tab>
            </v-tabs>
            <div>
                <div v-if="activeTab === 0" class="d-flex py-1">
                    <v-text-field-filled
                        v-model="search"
                        label="Rechercher"
                        outlined
                        hide-details
                        density="compact"
                        append-inner-icon="$search"
                        clearable
                        @click:clear="search = ''"
                    />
                    <v-btn
                        v-if="enableWrite && localEnv !== 'production'"
                        class="ml-2 mr-0 elevation-0"
                        rounded="xl"
                        density="compact"
                        variant="flat"
                        @click="step = 'editionTutorials'"
                    >
                        Ajouter
                    </v-btn>
                </div>
                <div v-if="activeTab === 2" class="d-flex py-1">
                    <v-row no-gutters>
                        <v-col cols="10">
                            <v-select-filled
                                v-model="selectedCategories"
                                :items="allCategories"
                                item-value="value"
                                label="Catégories de tutoriels"
                                multiple
                                small-chips
                                outlined
                                hide-details
                                clearable
                                style="overflow-x: auto; flex-wrap: nowrap"
                                density="compact"
                                :item-title="(item: any) => item.text"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip v-if="index < 3" :key="item.value" size="x-small">
                                        {{ item.title }}
                                    </v-chip>
                                    <v-chip v-if="index === 3" :key="'more-items'" size="x-small">
                                        + {{ selectedCategories.length - 3 }} autres
                                    </v-chip>
                                </template>
                            </v-select-filled>
                        </v-col>
                        <v-col cols="2">
                            <v-btn-toggle v-model="viewMode" rounded="xl" class="ml-2 pl-2">
                                <v-btn-icon value="doughnut" icon="$fa-chart-pie" />
                                <v-btn-icon value="bar" icon="$fa-chart-bar" />
                                <v-btn-icon value="table" icon="$fa-list-ul" />
                            </v-btn-toggle>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>
        <v-window v-model="activeTab">
            <v-window-item value="0">
                <v-window v-model="step">
                    <v-window-item value="tutorials">
                        <!-- <div class="d-flex py-1">
                            <v-text-field
                                v-model="search"
                                label="Rechercher un tuto"
                                outlined
                                class="oss-dark"
                                density="compact"
                                hide-details
                            ></v-text-field>
                            <v-btn
                                v-if="enableWrite && localEnv !== 'production'"
                                class="ml-2 mr-0 elevation-0"
                                color="primary"
                                dark
                                rounded
                                density="compact"
                                @click="step = 'editionTutorials'"
                            >
                                Ajouter
                            </v-btn>
                        </div> -->
                        <v-list v-if="starterComponents">
                            <v-list-item
                                v-for="tuto of filteredTutos"
                                :key="tuto.id"
                                class="my-2"
                                @click="setSelectedTuto(tuto.id)"
                                lines="two"
                                border
                                :title="tuto.name"
                                :subtitle="tuto.description"
                                rounded="xl"
                            >
                                <template #prepend>
                                    <v-icon>$fa-photo-video</v-icon>
                                    <!-- Utilisation de prepend pour les icônes -->
                                </template>

                                <!-- <v-list-item-title v-text="tuto.name"></v-list-item-title>
                                <v-list-item-subtitle v-text="tuto.description"></v-list-item-subtitle> -->

                                <template #append>
                                    <v-tooltip location="bottom">
                                        <template v-slot:activator="{ props }">
                                            <v-btn-trash
                                                size="small"
                                                v-bind="props"
                                                @click.stop="deleteTutorial(tuto)"
                                            />
                                        </template>
                                        <span>Supprimer</span>
                                    </v-tooltip>
                                    <v-tooltip location="bottom">
                                        <template v-slot:activator="{ props }">
                                            <v-progress-circular
                                                v-if="!isTutorialCompleted(tuto)"
                                                v-bind="props"
                                                :model-value="calculateProgress(tuto)"
                                                size="24"
                                                width="3"
                                                color="primary"
                                                rounded
                                            />
                                            <v-icon
                                                v-if="isTutorialCompleted(tuto)"
                                                size="24"
                                                width="3"
                                                v-bind="props"
                                            >
                                                $oss-circle-check
                                            </v-icon>
                                        </template>
                                        <span>{{ getTutorialStatus(tuto) }}</span>
                                    </v-tooltip>
                                </template>
                            </v-list-item>
                        </v-list>

                        <v-list v-else>
                            <template v-if="!search">
                                <v-list-item
                                    v-for="path of pathsToDisplay"
                                    :key="path[pathLevel]"
                                    class="my-2"
                                    @click="goTo(path[pathLevel])"
                                    lines="two"
                                    border
                                    :title="formatFolderTitle(path[pathLevel])"
                                    rounded="xl"
                                >
                                    <template #prepend>
                                        <v-icon>$fa-folder</v-icon>
                                    </template>

                                    <!-- <v-list-item-title v-text="formatFolderTitle(path[pathLevel])"></v-list-item-title> -->

                                    <template #append>
                                        <v-icon>$oss-chevron-right</v-icon>
                                    </template>
                                </v-list-item>
                            </template>

                            <v-list-item
                                v-for="tuto of filteredTutos"
                                :key="tuto.id"
                                class="my-2"
                                @click="setSelectedTuto(tuto.id)"
                                lines="two"
                                border
                                :title="tuto.name"
                                :subtitle="tuto.description"
                                rounded="xl"
                            >
                                <template #prepend>
                                    <v-icon>$fa-photo-video</v-icon>
                                </template>
                                <template #append>
                                    <v-tooltip location="bottom">
                                        <template v-slot:activator="{ props }">
                                            <v-btn-trash
                                                size="small"
                                                v-bind="props"
                                                @click.stop="deleteTutorial(tuto)"
                                            />
                                        </template>
                                        <span>Supprimer</span>
                                    </v-tooltip>

                                    <v-tooltip location="bottom">
                                        <template v-slot:activator="{ props }">
                                            <v-progress-circular
                                                v-if="!isTutorialCompleted(tuto)"
                                                v-bind="props"
                                                :model-value="calculateProgress(tuto)"
                                                color="primary"
                                                size="24"
                                                width="3"
                                                rounded
                                            />
                                            <v-icon
                                                v-else="isTutorialCompleted(tuto)"
                                                size="24"
                                                width="3"
                                                v-bind="props"
                                                color="primary"
                                            >
                                                $oss-circle-check
                                            </v-icon>
                                        </template>
                                        <span>{{ getTutorialStatus(tuto) }}</span>
                                    </v-tooltip>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-window-item>

                    <v-window-item value="displayTutorial">
                        <div v-html="previewHTML" />
                    </v-window-item>

                    <v-window-item value="editionTutorials">
                        <!-- Content for editing or creating a tutorial -->
                        <v-row no-gutters>
                            <v-col cols="12">
                                <div
                                    v-html="previewHTML"
                                    :style="{
                                        width: '500px',
                                    }"
                                />
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="pt-1">
                            <v-col cols="5">
                                <v-text-field-filled
                                    v-model="tutorialEdition.name"
                                    label="Nom"
                                    outlined
                                    class="pr-1"
                                    density="compact"
                                    hide-details
                                />
                            </v-col>
                            <v-col cols="3">
                                <v-select-filled
                                    v-model="tutorialEdition.status"
                                    label="statut"
                                    class="pr-1"
                                    :items="status"
                                    item-value="value"
                                    :item-title="(item: any) => item.text"
                                    density="compact"
                                    outlined
                                />
                            </v-col>
                            <v-col cols="2">
                                <v-text-field-filled
                                    v-model.number="tutorialEdition.estimatedDuration"
                                    label="Durée estimée (en secondes)"
                                    outlined
                                    class="pr-1"
                                    density="compact"
                                    hide-details
                                />
                            </v-col>
                            <v-col cols="2">
                                <v-text-field-filled
                                    v-model.number="tutorialEdition.stepCount"
                                    label="Nombre d'étapes"
                                    outlined
                                    density="compact"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field-filled
                                    v-model="tutorialEdition.description"
                                    label="Description"
                                    outlined
                                    density="compact"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea-filled
                                    v-model="tutorialEdition.embedCode"
                                    label="Embed code"
                                    :placeholder="`<div>\n    ...\n</div>`"
                                    outlined
                                    density="compact"
                                    hide-details
                                    @change="onEmbedCodeChange"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field-filled
                                    v-model="tutorialEdition.url"
                                    label="Url"
                                    outlined
                                    density="compact"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" v-if="tutorialEdition.id && enableWrite">
                                <v-text-field-filled
                                    v-model="tutorialEdition.key"
                                    label="Key"
                                    outlined
                                    density="compact"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-combobox-filled
                                    v-model="tutorialEdition.starterComponents"
                                    :items="referencedComponents"
                                    label="Nom des composants"
                                    density="compact"
                                    multiple
                                    persistent-hint
                                    outlined
                                    chips
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-combobox-filled
                                    v-model="tutorialEdition.path"
                                    :items="referencedPaths"
                                    label="Chemin d'accès"
                                    density="compact"
                                    multiple
                                    hint="Utiliser '/' pour séparer les menus"
                                    persistent-hint
                                    outlined
                                    chips
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-combobox-filled
                                    v-model="tutorialEdition.tags"
                                    label="&#xc9;tiquettes"
                                    density="compact"
                                    multiple
                                    outlined
                                    chips
                                    hide-details
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-combobox-filled
                                    v-model="tutorialEdition.authorizedFor"
                                    label="Autorisations"
                                    :items="authorizationList"
                                    density="compact"
                                    multiple
                                    outlined
                                    chips
                                    hide-details
                                    clearable
                                >
                                    <template #item="{ item }">
                                        <v-checkbox
                                            :label="formatText(item)"
                                            :model-value="
                                                tutorialEdition.authorizedFor.includes(
                                                    normalizeItem(item),
                                                )
                                            "
                                            color="primary"
                                            density="compact"
                                            size="small"
                                            hide-details
                                            @update:model-value="
                                                (checked) => {
                                                    const rawValue = normalizeItem(item);
                                                    if (checked) {
                                                        if (
                                                            !tutorialEdition.authorizedFor.includes(
                                                                rawValue,
                                                            )
                                                        ) {
                                                            tutorialEdition.authorizedFor.push(
                                                                rawValue,
                                                            );
                                                        }
                                                    } else {
                                                        const index =
                                                            tutorialEdition.authorizedFor.indexOf(
                                                                rawValue,
                                                            );
                                                        if (index > -1) {
                                                            tutorialEdition.authorizedFor.splice(
                                                                index,
                                                                1,
                                                            );
                                                        }
                                                    }
                                                }
                                            "
                                        />
                                    </template>
                                    <template #selection="{ item }">
                                        <v-chip>{{ formatText(item) }}</v-chip>
                                    </template>
                                </v-combobox-filled>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="d-flex justify-end">
                                <v-btn
                                    class="ml-2 mr-0 elevation-0"
                                    color="primary"
                                    v-if="
                                        tutorialEdition.id &&
                                        enableWrite &&
                                        localEnv !== 'production'
                                    "
                                    dark
                                    rounded
                                    density="compact"
                                    outlined
                                    @click="deleteTutorial(tutorialEdition)"
                                >
                                    Supprimer
                                </v-btn>
                                <v-btn
                                    class="ml-2 mr-0 elevation-0"
                                    color="primary"
                                    rounded
                                    density="compact"
                                    :disabled="disabledBtn"
                                    @click="sendTutorialEdition(tutorialEdition)"
                                >
                                    Valider
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-window-item>
                </v-window>
            </v-window-item>
            <v-window-item :value="1">
                <TutorialsModules v-if="activeTab === 1" ref="tutorialsModules"> </TutorialsModules>
            </v-window-item>
            <v-window-item :value="2">
                <v-container>
                    <v-row v-if="filteredTutorialsForCurrentUser.length > 0">
                        <v-col v-if="viewMode === 'doughnut' && !starterComponents">
                            <DoughnutChart
                                v-if="chartDataDoughnut"
                                :data="chartDataDoughnut"
                                :options="doughnutChartOptions"
                                :height="$vuetify.display.mobile ? 200 : 350"
                            >
                            </DoughnutChart>
                            <div class="doughnut-center-text" v-if="chartDataDoughnut">
                                {{ globalProgress }}%
                            </div>
                        </v-col>
                        <v-col v-else-if="viewMode === 'bar'">
                            <BarChart
                                v-if="horizontalBarChartData"
                                :data="horizontalBarChartData"
                                :options="horizontalBarChartOptions"
                                :height="300"
                            />
                        </v-col>
                        <v-col v-else-if="viewMode === 'table'">
                            <v-data-table
                                :headers="tableHeaders"
                                :items="filteredTutorialsForCurrentUser"
                                item-key="learningObjectId"
                                class="elevation-1 table"
                            >
                                <template v-slot:item.progress="{ item }">
                                    <v-progress-circular
                                        v-if="!isTutorialCompleted(item)"
                                        :model-value="calculateProgress(item)"
                                        color="primary"
                                        size="24"
                                        width="3"
                                    />
                                    <v-icon
                                        v-if="isTutorialCompleted(item)"
                                        size="24"
                                        width="3"
                                        color="primary"
                                    >
                                        $oss-circle-check
                                    </v-icon>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-col>
                            <div class="text-center">
                                <p>Veuillez sélectionner au moins une catégorie.</p>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-window-item>
        </v-window>
    </div>
</template>

<script lang="ts">
import { uniq, uniqBy } from "lodash";
import { User } from "../../store/store";

import UPSERT_TUTORIALS from "../../graphql/tutorials/UpsertTutorials.gql";
import DELETE_TUTORIAL from "../../graphql/tutorials/DeleteTutorial.gql";
import TUTORIAL from "../../graphql/tutorials/Tutorial.gql";
import UPSERT_ACTIVITY_STEP_COUNT from "../../graphql/usersActivities/UpsertUserActivityStepCount.gql";

import getEnv from "../../env";

import { Doughnut as DoughnutChart, Bar as BarChart } from "vue-chartjs";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Ref } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

import TutorialsModules from "./TutorialsModules.vue";
import { TutorialsModules as TutorialsModulesType } from "./TutorialsModules.vue";
import { ProfileConfiguration } from "../../../../backend/src/common/profile/profile";

// ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const env = getEnv();

@Component({
    components: {
        DoughnutChart,
        BarChart,
        TutorialsModules,
    },
    emits: ["refresh"],
})
export class TutorialsList extends Vue {
    @Prop({ default: null }) starterComponents: string | null; // Open tutorials from the given starter component
    @Prop({ default: () => [] }) tutorials: any[]; // Pass tutorials as prop

    @Ref("tutorialsModules") tutorialsModules: TutorialsModulesType;

    localEnv = env.environnement;

    step: "tutorials" | "editionTutorials" | "displayTutorial" = "tutorials";
    search = "";

    categorySelectionMode: string = "Tous"; // Par défaut sur "Tous"
    categorySelectionOptions: Array<any> = [
        { text: "Tous", value: "Tous" },
        { text: "Par catégorie", value: "Par catégorie" },
    ];

    lastArcadeEvent: any = null;

    viewMode: string = "doughnut";

    status = [
        {
            text: "Brouillon",
            value: "DRAFT",
        },
        {
            text: "Publié",
            value: "PUBLISHED",
        },
    ];

    currentPath = "";
    selectedTuto = null;

    tutorialEdition = {
        id: "",
        name: "",
        description: "",
        url: "",
        status: "",
        estimatedDuration: 0,
        stepCount: 0,
        key: "",
        path: [] as string[],
        tags: [] as string[],
        starterComponents: [] as string[],
        type: "IFRAM",
        embedCode: "",
        authorizedFor: [] as string[],
        UserActivity: [],
    };

    activeTab: number = 0;

    selectedCategories: Array<any> = [];

    selectedStatus: string | null = null;

    arcadeSteps: Array<any> = [];

    hasNavigatedToSavedStep: Map<string, boolean> = new Map();

    beforeMount() {
        window.addEventListener("message", this.handleMessage);
        if (this.selectedCategories?.length === 0) {
            this.selectedCategories = this.referencedPaths.map((path) => {
                return {
                    text: this.formatFolderTitle(path),
                    value: path,
                };
            });
        }

        if (this.starterComponents?.length) {
            this.viewMode = "bar";
        }
    }

    mounted() {
        // Set the active tab to 1 if the tutorialsModules ( getStarted ) prop is not empty
        if (
            this.starterComponents === "Sans starterComponents" ||
            this.starterComponents === null ||
            this.localEnv !== "production"
        ) {
            if (this.tutorialsModules && this.tutorialsModules.tutorialsModules?.length) {
                this.activeTab = 1;
                console.log("Active tab set to 1");
            } else {
                console.warn("No tutorialsModules found or tutorialsModules is empty");
            }
        } else {
            console.log("Conditions not met for setting active tab");
        }
    }

    beforeDestroy() {
        window.removeEventListener("message", this.handleMessage);
        if (this.lastArcadeEvent) {
            this.upsertUserStepCount(this.lastArcadeEvent);
        }
    }

    destroyed() {
        // Update the userActivity
    }

    handleMessage({ data }) {
        if (data.event === "arcade-state-update") {
            this.onArcadeTutorialStepChanged(data);
        }
    }

    get allAvailableCompanies() {
        const companies = [];
        this.currentUser.allAvailableCompanies.forEach((company) => {
            companies.push({
                value: company.id,
                key: company.name,
            });
            companies.sort((a, b) => {
                if (a.key < b.key) return -1;
                if (a.key > b.key) return 1;
                return 0;
            });
        });

        return companies;
    }

    /** Returns a list of filtered tutorials based on the search query and current path.
     * @returns An array of filtered tutorials.
     */
    get filteredTutos() {
        let filteredTutos = JSON.parse(JSON.stringify(this.tutorials));

        if (this.search) {
            filteredTutos = filteredTutos.filter((tuto: any) => {
                return (
                    tuto.name.includes(this.search) ||
                    tuto.description.includes(this.search) ||
                    (tuto.tags && tuto.tags.includes(this.search))
                );
            });
        }
        if (this.currentPath) {
            if (this.currentPath.endsWith(";")) {
                this.currentPath = this.currentPath.slice(0, -1);
            }
            filteredTutos = filteredTutos.filter((tuto: any) => {
                return (
                    tuto.path.startsWith(`${this.currentPath};`) ||
                    tuto.path.includes(`;${this.currentPath};`)
                );
            });
        }
        if (!this.currentPath && !this.search && !this.starterComponents) {
            return [];
        }

        // filteredTutos = filteredTutos.filter((tuto: any) =>
        //     this.checkAuthorizations(tuto.authorizedFor)
        // );

        return filteredTutos;
    }

    get statusOptions() {
        return ["Pas commencé", "En cours", "Terminé"];
    }

    get allCategories() {
        return [
            ...this.referencedPaths.map((path) => {
                return {
                    text: this.formatFolderTitle(path),
                    value: path,
                };
            }),
        ];
    }

    /** Retrieves the current user from the Vuex store.
     * @returns The current user object.
     */
    get currentUser(): User {
        return this.$store.state.user;
    }

    /** Determines if the current user has write permissions.
     * @returns A boolean indicating if write permissions are enabled.
     */
    get enableWrite() {
        if (this.currentUser.isRoot) {
            return true;
        }
        // if (this.currentUser.email?.endsWith("@oss360.com") || this.currentUser.email?.endsWith("@bobbeelab.com")) {
        //     return true;
        // }
        return false;
    }

    /** Retrieves the authorization list for the current user.
     * @returns An array of authorized paths.
     */
    get authorizationList() {
        const paths = this.getPaths(this.currentUser.profile.configuration);

        if (!Array.isArray(paths)) {
            console.warn("getPaths did not return an array. Defaulting to an empty array.");
            return [];
        }

        const validPaths = paths
            .filter((path) => typeof path === "string")
            .map((path) => path.trim());

        console.log("Valid Paths:", validPaths);
        return validPaths;
    }

    /** Determines if the preview should be displayed.
     * @returns A boolean indicating if the preview is enabled.
     */
    get displayPreview() {
        return !!this.previewHTML;
    }

    /** Retrieves the HTML for the tutorial preview based on its type.
     * @returns A string containing the HTML for the preview.
     */
    get previewHTML() {
        if (this.tutorialEdition?.url.includes("arcade.software")) {
            this.tutorialEdition.type = "IFRAM";

            return this.tutorialEdition.embedCode;
        } else if (this.tutorialEdition?.url.includes("docs.google.com")) {
            this.tutorialEdition.type = "IFRAM";
            return `<div style="height: 60%; width: 100%">${this.tutorialEdition.embedCode}</div>`;
        } else if (this.tutorialEdition?.url.includes("amazonaws.com/video")) {
            this.tutorialEdition.type = "VIDEO";
            return `<video src="${this.tutorialEdition.url}" controls style="width: 100%; height: 100%;"></video>`;
        } else {
            return "";
        }
    }

    /** Retrieves the list of referenced paths from the tutorials.
     * @returns An array of referenced paths.
     */
    get referencedPaths() {
        if (this.tutorials) {
            const paths = this.tutorials.flatMap((t: any) =>
                t.path ? t.path.split(";").filter(Boolean) : [],
            );
            return uniq(paths);
        } else {
            return [];
        }
    }

    /** Retrieves the list of referenced starter components from the tutorials.
     * @returns An array of referenced starter components.
     */
    get referencedComponents() {
        if (this.tutorials) {
            return uniq(
                this.tutorials.flatMap((t: any) =>
                    t.starterComponents ? t.starterComponents.split(";") : [],
                ),
            );
        } else {
            return [];
        }
    }

    /** Retrieves the paths to be displayed based on the current search and path level.
     * @returns An array of paths to display.
     */
    get pathsToDisplay() {
        if (this.search) {
            return [];
        }
        return uniqBy(
            this.referencedPaths
                .filter((path) => {
                    if (this.currentPath.length) {
                        return path.startsWith(this.currentPath + "/");
                    }
                    return true;
                })
                .flatMap((path) => {
                    let p = path.split("/");
                    const result = [];
                    while (result.length < p.length) {
                        result.push(p.slice(0, result.length + 1));
                    }
                    return result;
                }),
            (x) => {
                return (x[this.pathLevel] || "").toString();
            },
        )
            .filter((p) => !!p[this.pathLevel])
            .sort((b1, b2) => {
                return b1[this.pathLevel] < b2[this.pathLevel] ? -1 : 1;
            });
    }

    /** Determines if the submit button should be disabled based on tutorial details.
     * @returns A boolean indicating if the button is disabled.
     */
    get disabledBtn() {
        if (
            this.tutorialEdition.name &&
            this.tutorialEdition.url &&
            this.tutorialEdition.status &&
            this.tutorialEdition.path.length > 0 &&
            this.tutorialEdition.type
        ) {
            return false;
        } else {
            return true;
        }
    }

    /** Calculates the current path level based on the current path.
     * @returns The current path level as an integer.
     */
    get pathLevel() {
        let pathLevels = this.currentPath.split("/").filter((x) => !!x.length);
        return pathLevels.length;
    }

    /** Returns the headers for the data table in the Suivi personnel tab. */
    get tableHeaders() {
        return [
            { title: "Nom du tutoriel", value: "name" },
            { title: "Chemin", value: "path" },
            { title: "Description", value: "description" },
            { title: "Pourcentage de complétion", value: "progressPercentage" },
            { title: "Statut", value: "progress" },
        ];
    }

    /** Returns the filtered tutorials for the current user. */
    get filteredTutorialsForCurrentUser() {
        let filteredTutorials = this.tutorials;

        // Filtrer les tutoriels en fonction de categorySelectionMode
        if (this.selectedCategories?.length !== this.allCategories?.length) {
            filteredTutorials = filteredTutorials.filter((tutorial) => {
                const paths = tutorial.path ? tutorial.path.split(";") : [];
                return this.selectedCategories.some((category) => paths.includes(category));
            });
        }

        // Filtrer les tutoriels en fonction du statut sélectionné
        if (this.selectedStatus && this.viewMode === "table") {
            filteredTutorials = filteredTutorials.filter((tutorial) => {
                const progress = this.calculateProgress(tutorial);
                if (this.selectedStatus === "Pas commencé" && progress > 0) return false;
                if (this.selectedStatus === "En cours" && (progress === 0 || progress === 100))
                    return false;
                if (this.selectedStatus === "Terminé" && progress < 100) return false;
                return true;
            });
        }

        // Mapper les tutoriels filtrés pour inclure les informations de progression et autres détails
        return filteredTutorials.map((tutorial) => {
            const progress = this.calculateProgress(tutorial);
            return {
                name: tutorial.name,
                path: this.formatFolderTitle(tutorial.path).endsWith(";")
                    ? this.formatFolderTitle(tutorial.path).slice(0, -1)
                    : this.formatFolderTitle(tutorial.path),
                description: tutorial.description || "N/A",
                progressPercentage: `${Math.round(progress)} %`,
                learningObjectId: tutorial.id,
                UserActivity: tutorial.UserActivity,
                stepCount: tutorial.stepCount,
            };
        });
    }

    get globalProgress() {
        const tutorials = this.filteredTutorialsForCurrentUser;

        if (tutorials.length === 0) {
            return 0;
        }

        // Calculer la somme totale des stepCount de tous les tutoriels
        const totalTutorialSteps = tutorials.reduce((acc, tutorial) => {
            if (typeof tutorial.stepCount === "number" && tutorial.stepCount > 0) {
                return acc + tutorial.stepCount;
            }
            return acc;
        }, 0);

        // Calculer la somme totale des userStepCount pour chaque tutoriel
        const totalUserSteps = tutorials.reduce((acc, tutorial) => {
            if (tutorial.UserActivity && tutorial.UserActivity.length > 0) {
                const userActivity = tutorial.UserActivity[0];
                if (typeof userActivity.stepCount === "number" && userActivity.stepCount > 0) {
                    return acc + userActivity.stepCount;
                }
            }
            return acc;
        }, 0);

        // Vérifier si totalTutorialSteps est supérieur à zéro pour éviter une division par zéro
        if (totalTutorialSteps === 0) {
            return 0;
        }

        // Calculer le pourcentage global de progression
        const globalProgress = (totalUserSteps / totalTutorialSteps) * 100;

        return Math.round(globalProgress);
    }

    get chartDataDoughnut() {
        const stats = {
            notStarted: 0,
            inProgress: 0,
            completed: 0,
        };

        this.filteredTutorialsForCurrentUser.forEach((tutorial) => {
            const progress = this.calculateProgress(tutorial);
            if (progress === 0) {
                stats.notStarted++;
            } else if (progress > 0 && progress < 100) {
                stats.inProgress++;
            } else if (progress === 100) {
                stats.completed++;
            }
        });

        return {
            labels: ["Pas commencé", "En cours", "Terminé"],
            datasets: [
                {
                    data: [stats.notStarted, stats.inProgress, stats.completed],
                    backgroundColor: ["#F44336", "#FF9800", "#4CAF50"],
                },
            ],
        };
    }

    get doughnutChartOptions() {
        return {
            plugins: {
                legend: {
                    display: this.$vuetify.display.mobile ? false : true,
                    position: "bottom",
                },
                tooltip: {
                    enabled: true,
                },
            },
            maintainAspectRatio: false,
        };
    }

    get histogramChartData() {
        const progressCounts: { [key: string]: number } = {
            "0-10%": 0,
            "11-20%": 0,
            "21-30%": 0,
            "31-40%": 0,
            "41-50%": 0,
            "51-60%": 0,
            "61-70%": 0,
            "71-80%": 0,
            "81-90%": 0,
            "91-100%": 0,
        };

        this.filteredTutorialsForCurrentUser.forEach((tutorial) => {
            const progress = this.calculateProgress(tutorial);
            if (progress >= 0 && progress <= 10) progressCounts["0-10%"]++;
            else if (progress > 10 && progress <= 20) progressCounts["11-20%"]++;
            else if (progress > 20 && progress <= 30) progressCounts["21-30%"]++;
            else if (progress > 30 && progress <= 40) progressCounts["31-40%"]++;
            else if (progress > 40 && progress <= 50) progressCounts["41-50%"]++;
            else if (progress > 50 && progress <= 60) progressCounts["51-60%"]++;
            else if (progress > 60 && progress <= 70) progressCounts["61-70%"]++;
            else if (progress > 70 && progress <= 80) progressCounts["71-80%"]++;
            else if (progress > 80 && progress <= 90) progressCounts["81-90%"]++;
            else if (progress > 90 && progress <= 100) progressCounts["91-100%"]++;
        });

        return {
            labels: Object.keys(progressCounts),
            datasets: [
                {
                    label: "Nombre de Tutoriels",
                    data: Object.values(progressCounts),
                    backgroundColor: "#f9b129",
                    borderColor: "#1E88E5",
                    borderWidth: 1,
                },
            ],
        };
    }

    get histogramChartOptions() {
        return {
            responsive: true,
            plugins: {
                legend: {
                    display: true,
                },
                tooltip: {
                    callbacks: {
                        label: (tooltipItem: any) => `Nombre de Tutoriels: ${tooltipItem.raw}`,
                    },
                },
            },
        };
    }

    get horizontalBarChartData() {
        const groupedTutorials = this.filteredTutorialsForCurrentUser.reduce((acc, tutorial) => {
            const paths = tutorial.path ? tutorial.path.split(";") : [];
            paths.forEach((path) => {
                if (!acc[path]) {
                    acc[path] = [];
                }
                acc[path].push(tutorial);
            });
            return acc;
        }, {});

        // Préparer les labels (noms des catégories) et les datasets (données de progression)
        const labels = Object.keys(groupedTutorials);
        if (labels?.length) {
            const data = labels.map((label) => {
                const tutorials = groupedTutorials[label];
                const progress = tutorials.reduce(
                    (acc, tutorial) => acc + this.calculateProgress(tutorial),
                    0,
                );
                return progress / tutorials.length;
            });

            if (data?.length) {
                data.forEach((value, index) => {
                    data[index] = Math.round(value);
                });
            }
            return {
                labels: labels,
                datasets: [
                    {
                        label: "Progression des Tutoriels par catégorie (%)",
                        data: data,
                        backgroundColor: "#f9b129",
                        borderColor: "#000000",
                        borderWidth: 1,
                        categoryPercentage: 1,
                        barPercentage: 0.3,
                    },
                ],
            };
        }
        return null;
    }

    get horizontalBarChartOptions() {
        return {
            indexAxis: "y", // Permet de rendre les barres horizontales
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                    beginAtZero: true,
                    max: 100, // Pour limiter l'axe des X à 100%
                    ticks: {
                        stepSize: 10, // Pour afficher les pourcentages de 10 en 10
                        callback: (value: number) => `${value}%`, // Formater les ticks en pourcentage
                    },
                },
                y: {
                    grid: {
                        // Supprime les lignes de grille horizontales
                        display: false,
                    },
                },
            },
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        label: (tooltipItem: any) => `Progression: ${tooltipItem.raw}%`,
                    },
                },
            },
        };
    }

    get currentUserStepCount() {
        if (this.tutorialEdition.UserActivity?.length) {
            return this.tutorialEdition.UserActivity[0].stepCount;
        }
        return 0;
    }

    /** Méthode appelée lors du changement de catégorie */
    @Watch("viewMode")
    @Watch("categorySelectionMode")
    onCategorySelectionModeChange() {
        if (this.categorySelectionMode === "Par catégorie") {
            // this.selectedCategories = [];
            // this.selectedStatus = null;
            if (this.viewMode === "doughnut") {
                this.viewMode = "bar";
            }
        }
    }

    @Watch("tutorialEdition.id")
    onTutorialEditionIdChange(newId: string) {
        if (newId) {
            this.hasNavigatedToSavedStep.set(newId, false);
        }
    }

    /**
     * @param event The event object retrieve from Arcade.
     *
     */
    async onArcadeTutorialStepChanged(event: any) {
        const tutorialId = this.tutorialEdition.id;
        let userActivity = this.tutorialEdition?.UserActivity?.[0];

        if (tutorialId && event.arcade.steps) {
            this.lastArcadeEvent = event; // Stocker l'événement

            const steps = event.arcade.steps;

            if (steps) {
                this.arcadeSteps = steps || [];

                // Navigation vers l'étape sauvegardée si nécessaire
                if (this.arcadeSteps?.length && !this.hasNavigatedToSavedStep.get(tutorialId)) {
                    if (userActivity?.stepCount) {
                        const activeStep = this.arcadeSteps.find(
                            (step) => step.order === userActivity.stepCount,
                        );

                        if (activeStep?.id) {
                            await this.checkIframeAndNavigate(activeStep.id);
                            this.hasNavigatedToSavedStep.set(tutorialId, true);
                        }
                    }
                }
            }

            if (!userActivity) {
                const { data } = await this.$apollo.mutate({
                    mutation: UPSERT_ACTIVITY_STEP_COUNT,
                    variables: {
                        id: "",
                        userId: this.currentUser.id,
                        learningObjectId: tutorialId,
                        userStepCount: 0,
                        tutorialStepCount: this.tutorialEdition.stepCount,
                    },
                });
                userActivity = data?.upsertUserActivityStepCount;
                this.tutorialEdition.UserActivity = [userActivity];
            }
        }
    }

    async upsertUserStepCount(event: any) {
        const tutorialId = this.tutorialEdition.id;
        const userActivity = this.tutorialEdition.UserActivity?.[0];

        if (tutorialId && userActivity) {
            const activeStep = event.arcade.steps.find((step: any) => step.isActive);
            if (activeStep) {
                await this.$apollo.mutate({
                    mutation: UPSERT_ACTIVITY_STEP_COUNT,
                    variables: {
                        id: userActivity.id,
                        userId: this.currentUser.id,
                        learningObjectId: tutorialId,
                        userStepCount: activeStep.order,
                        tutorialStepCount: this.tutorialEdition.stepCount,
                    },
                });
            }
        }
    }

    /** Sends the edited tutorial to the server for upsert.
     * @param tuto The tutorial to be upserted.
     */
    async sendTutorialEdition(tuto) {
        await this.$apollo.mutate({
            mutation: UPSERT_TUTORIALS,
            variables: {
                id: tuto.id || "",
                name: tuto.name,
                description: tuto.description,
                url: tuto.url,
                embedCode: tuto.embedCode,
                status: tuto.status,
                path: tuto.path ? tuto.path.join(";") + ";" : "",
                tags: tuto.tags ? tuto.tags.join(";") + ";" : "",
                starterComponents: tuto.starterComponents
                    ? tuto.starterComponents.join(";") + ";"
                    : "",
                type: tuto.type,
                authorizedFor: tuto.authorizedFor ? tuto.authorizedFor.join(";") + ";" : "",
                estimatedDuration: tuto.estimatedDuration ? tuto.estimatedDuration : 180,
                stepCount: tuto.stepCount ? tuto.stepCount : 0,
            },
        });
        this.step = "tutorials";
        this.currentPath = "";
        this.tutorialEdition = {
            id: "",
            name: "",
            description: "",
            url: "",
            status: "",
            estimatedDuration: 0,
            stepCount: 0,
            key: "",
            path: [],
            tags: [],
            starterComponents: [],
            type: "IFRAM",
            embedCode: "",
            authorizedFor: [],
            UserActivity: [],
        };
        this.refresh();
    }

    /** Navigates to a given path by appending it to the current path.
     * @param path The path to navigate to.
     */
    goTo(path) {
        if (this.currentPath.length) {
            this.currentPath += "/";
        }
        this.currentPath += path;
    }

    /** Navigates back in the path or changes the step to "tutorials".
     */
    goBack() {
        if (this.step === "tutorials") {
            const newPath = this.currentPath.split("/");
            newPath.pop();
            this.currentPath = newPath.join("/");
            return;
        }
        this.step = "tutorials";
        return;
    }

    /** Sets the selected tutorial for editing or displaying.
     * @param tutoId The tutorial ID to be selected.
     */
    async setSelectedTuto(tutoId: any) {
        // Clear all tutorialEdition fields
        if (this.tutorialEdition && this.tutorialEdition.id) {
            this.tutorialEdition = {
                id: "",
                name: "",
                description: "",
                url: "",
                status: "",
                path: [],
                tags: [],
                type: "IFRAM",
                key: "",
                embedCode: "",
                authorizedFor: [],
                starterComponents: [],
                UserActivity: [],
                estimatedDuration: 0,
                stepCount: 0,
            };
        }

        if (tutoId) {
            try {
                // Query to retrieve the complete tutorial from the backend
                const { data } = await this.$apollo.query({
                    query: TUTORIAL,
                    variables: {
                        id: tutoId,
                    },
                    fetchPolicy: "network-only",
                });

                let dbTutorial = null;

                if (data?.tutorial?.tutorial) {
                    dbTutorial = data.tutorial.tutorial;
                }

                if (dbTutorial) {
                    this.tutorialEdition = JSON.parse(JSON.stringify(dbTutorial));
                }
            } catch (error) {
                console.error("Failed to fetch the tutorial", error);
            }
        }

        // Process paths
        if (this.tutorialEdition.path) {
            this.tutorialEdition.path = this.tutorialEdition.path
                // @ts-ignore
                .split(";")
                .filter((x) => !!x.length);
        }

        // Process tags
        if (this.tutorialEdition.tags) {
            this.tutorialEdition.tags = this.tutorialEdition.tags
                // @ts-ignore
                .split(";")
                .filter((x) => !!x.length);
        }

        // Process authorizedFor
        if (this.tutorialEdition.authorizedFor) {
            this.tutorialEdition.authorizedFor = this.tutorialEdition.authorizedFor
                // @ts-ignore
                .split(";")
                .filter((x) => !!x.length);
        }

        // Process starterComponents
        if (this.tutorialEdition.starterComponents) {
            this.tutorialEdition.starterComponents = this.tutorialEdition.starterComponents
                // @ts-ignore
                .split(";")
                .filter((x) => !!x.length);
        }

        // Set the step based on enableWrite
        if (this.enableWrite) {
            this.step = "editionTutorials";
        } else {
            this.step = "displayTutorial";
        }
    }

    /** Deletes a tutorial by its ID.
     * @param tuto The tutorial to be deleted.
     */
    deleteTutorial(tuto) {
        this.$apollo.mutate({
            mutation: DELETE_TUTORIAL,
            variables: {
                id: tuto.id,
            },
        });
        this.step = "tutorials";
        this.currentPath = "";
        this.tutorialEdition = {
            id: "",
            name: "",
            description: "",
            url: "",
            status: "",
            estimatedDuration: 0,
            stepCount: 0,
            key: "",
            path: [],
            tags: [],
            starterComponents: [],
            type: "IFRAM",
            embedCode: "",
            authorizedFor: [],
            UserActivity: [],
        };
        this.refresh();
    }

    /** Formats the folder title by splitting on hyphens and rejoining.
     * @param folderName The folder name to format.
     * @returns The formatted folder title.
     */
    formatFolderTitle(folderName: string) {
        let name = folderName.split("-");
        if (name.length > 1) {
            return name.slice(1).join(" ");
        }
        return name.join(" ");
    }

    /** Updates the tutorial URL based on the embed code.
     */
    onEmbedCodeChange() {
        if (this.tutorialEdition.embedCode) {
            if (this.tutorialEdition.embedCode.includes("arcade.software")) {
                const url = this.tutorialEdition.embedCode.split('src="')[1].split('"')[0];
                this.tutorialEdition.url = url;
            }
            if (this.tutorialEdition.embedCode.includes("docs.google.com")) {
                const url = this.tutorialEdition.embedCode.split('src="')[1].split('"')[0];
                this.tutorialEdition.url = url;
                this.tutorialEdition.embedCode = this.tutorialEdition.embedCode.replace(
                    "></iframe>",
                    ' style="height: 70vh; width: 100%" frameBorder="0"></iframe>',
                );
            }
        }
    }

    /** Checks if the current user has authorization for a given path list.
     * @param pathsList The list of paths to check authorization for.
     * @returns A boolean indicating if the user is authorized.
     */
    checkAuthorizations(pathsList: string) {
        if (!pathsList) {
            return true;
        }

        if (
            this.currentUser.email?.endsWith("@oss360.com") ||
            this.currentUser.email?.endsWith("@bobbeelab.com")
        ) {
            return true;
        }

        const paths = pathsList.split(";").filter((x) => !!x.length);

        return paths.map((p) => this.checkAuthorization(p)).some((p) => p === true);
    }

    /** Checks if the current user has authorization for a specific path.
     * @param path The path to check.
     * @returns A boolean indicating if the user is authorized.
     */
    checkAuthorization(path: string): boolean {
        const _path = path.split(".");
        let currentPath = this.currentUser.profile.configuration;
        for (const p of _path) {
            if (!currentPath[p]) {
                return false;
            }
            currentPath = currentPath[p];
        }
        return true;
    }

    /**
     * Formats an authorization path into a readable string.
     * @param authorizationPath The path to format (can be a string or an object with a raw property).
     * @returns The formatted authorization path.
     */
    formatText(authorizationPath: any) {
        debugger;

        let pathString = "";

        if (typeof authorizationPath === "string") {
            pathString = authorizationPath;
        } else if (typeof authorizationPath === "object" && authorizationPath?.raw) {
            pathString = authorizationPath.raw;
        } else {
            console.warn("Invalid authorizationPath format:", authorizationPath);
            return "Invalid Path";
        }

        const [title, ...path] = pathString.split(".");

        return `${this.$t(`profile.${title}.title`)} - ${this.$t(
            `profile.${title}.values.${path.join(".")}`,
        )}`;
    }

    /**
     * Formats an authorization path into a readable string.
     * @param authorizationPath The path to format (can be a string or an object with a raw property).
     * @returns The formatted authorization path.
     */
    normalizeItem(item) {
        if (typeof item === "object" && item.raw) {
            return item.raw;
        } else if (typeof item === "object" && item.value) {
            return item.value;
        } else {
            return item;
        }
    }

    // /** Retrieves all paths from a given object recursively.
    //  * @param o The object to extract paths from.
    //  * @param root The root path (default is empty).
    //  * @param result The result array to store paths (default is empty).
    //  * @returns An array of paths.
    //  */
    // getPaths(o, root = "", result = []) {
    //     if (!o || typeof o !== "object") return [];

    //     const paths = [];
    //     const stack = [{ obj: o, path: [] }];

    //     while (stack.length > 0) {
    //         const { obj, path } = stack.pop();

    //         if (typeof obj === "object" && obj !== null) {
    //             for (const key in obj) {
    //                 stack.push({ obj: obj[key], path: [...path, key] });
    //             }
    //         } else {
    //             paths.push(path);
    //         }
    //     }

    //     return paths.map((path) => {
    //         return path.join(".");
    //     });
    // }

    /**
     * Retrieves all paths from a given object recursively.
     * @param obj The object to extract paths from.
     * @param parentPath The root path for recursion (used internally, default is an empty string).
     * @returns An array of string paths.
     */
    getPaths(obj, parentPath = "") {
        if (!obj || typeof obj !== "object") {
            return [];
        }

        const paths = [];

        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const currentPath = parentPath ? `${parentPath}.${key}` : key;

                if (typeof obj[key] === "object" && obj[key] !== null) {
                    paths.push(...this.getPaths(obj[key], currentPath));
                } else {
                    paths.push(currentPath);
                }
            }
        }

        return paths;
    }

    /** Calculates the progress percentage for a given tutorial.
     * @param tutorial The tutorial object.
     * @returns The progress percentage as a number.
     */
    calculateProgress(tutorial) {
        if (!tutorial.UserActivity || tutorial.UserActivity.length === 0) {
            return 0;
        }

        // Utiliser le stepCount du tutoriel et le userStepCount de l'utilisateur pour le calcul de progression
        const userActivity = tutorial.UserActivity[0];
        if (userActivity && typeof tutorial.stepCount === "number" && tutorial.stepCount > 0) {
            const progress = (userActivity.stepCount / tutorial.stepCount) * 100;
            return Math.min(Math.max(progress, 0), 100);
        } else {
            return 0;
        }
    }

    isTutorialCompleted(tutorial) {
        if (tutorial.progressPercentage) {
            return parseFloat(tutorial.progressPercentage.replace("%", "")) >= 100;
        }

        const progress = this.calculateProgress(tutorial);
        return progress >= 100;
    }

    getTutorialStatus(tutorial) {
        const progress = this.calculateProgress(tutorial);
        if (progress >= 100) {
            return "Terminé";
        } else if (progress > 0) {
            return "En cours";
        } else {
            return "Pas commencé";
        }
    }

    refresh() {
        this.$emit("refresh");
    }

    async checkIframeAndNavigate(stepId: string) {
        if (!stepId) {
            return;
        }

        return new Promise((resolve, reject) => {
            let attempts = 10;
            const prisma2Interval = setInterval(() => {
                const iframes = document.querySelectorAll("iframe");
                let iframe = Array.from(iframes).find((frame) =>
                    frame.src.includes("arcade.software"),
                );
                if (iframe) {
                    if (iframe.contentWindow) {
                        if (iframe.contentWindow?.postMessage) {
                            iframe.contentWindow.postMessage(
                                {
                                    event: "navigate-to-step",
                                    stepId: stepId,
                                },
                                "*",
                            );
                        } else {
                            debugger;
                        }
                        clearInterval(prisma2Interval);
                        resolve(null);
                    } else {
                        debugger;
                        console.error("iframe without contentWindow");
                    }
                } else {
                    attempts--;
                    if (attempts <= 0) {
                        clearInterval(prisma2Interval);
                        resolve(null);
                    }
                }
            }, 100);
        });

        // debugger;
        // const iframes = document.querySelectorAll('iframe');
        // let iframe = Array.from(iframes).find(frame => frame.src.includes('arcade.software'));

        // let attempts = 10;
        // while (!iframe && attempts > 0) {
        //     await new Promise(resolve => setTimeout(resolve, 500));
        //     iframe = Array.from(document.querySelectorAll('iframe')).find(frame => frame.src.includes('arcade.software'));
        //     attempts--;
        // }

        // if (iframe?.contentWindow && stepId) {
        //     iframe.contentWindow.postMessage(
        //         {
        //             event: 'navigate-to-step',
        //             stepId: stepId,
        //         },
        //         '*'
        //     );
        // } else {
        //     console.error('Failed to find the iframe or stepId is invalid');
        // }
    }

    removeItem(chip) {
        const index = this.selectedCategories.indexOf(chip.value);
        if (index !== -1) {
            this.selectedCategories.splice(index, 1);
        }
    }

    @Watch("starterComponents")
    onStarterComponentsChange() {
        if (this.starterComponents?.length) {
            // this.viewMode = 'bar';
        }
    }
}

export default toNative(TutorialsList);
</script>

<style scoped>
.doughnut-center-text {
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 2em;
    font-weight: bold;
    color: #000;
}

.v-combobox__selections {
    overflow-x: scroll;
    flex-wrap: nowrap;
}
.v-chip {
    overflow: initial;
}

.sticky-header {
    position: sticky;
    overflow: hidden;
    top: 0;
    z-index: 10;
    background-color: #fdfdfd;
    padding: 10px 0;
}

.content-area {
    height: calc(100vh - 160px);
    overflow-y: auto;
    padding-top: 10px;
}
</style>
